type EnvStringBoolean = 'true' | 'false' | '1' | '0' | 1 | 0;

export interface FrontendEnvType {
  NODE_ENV?: 'production' | 'development';
  TOKEN_REFRESH_URL?: string;
  PUBLIC_URL?: '' | string;
  REACT_APP_PUBLIC_URL?: '' | string;
  REACT_APP_AGGRID_CREDENTIALS?: string;
  REACT_APP_DESIRED_TABLE?: 'AgGrid' | string;
  REACT_APP_CGI_ECM_LINK?: string;
  REACT_APP_IS_COMPANY_V2?: EnvStringBoolean;
  REACT_APP_IS_DEV?: EnvStringBoolean;
  REACT_APP_IS_FEATURE_TOGGLES?: EnvStringBoolean;
  REACT_APP_IS_LENS?: EnvStringBoolean;
  REACT_APP_IS_NATIVE_AWS?: string;
  REACT_APP_IS_NEWS_V2?: EnvStringBoolean;
  REACT_APP_IS_SSO?: EnvStringBoolean;
  REACT_APP_IS_VERSION_DATA?: EnvStringBoolean;
  REACT_APP_IS_VOTING_DIFF_TOOL?: EnvStringBoolean;
  REACT_APP_IS_VOTING_V2?: EnvStringBoolean;
  REACT_APP_IS_INVESTOR_VOTING_PROFILE_ENABLED?: EnvStringBoolean;
  REACT_APP_IS_VOTING_QUICKVIEW_V2?: EnvStringBoolean;
  REACT_APP_ADVANCED_VOTING_DATA_SEARCH_DATA_VIEW?: EnvStringBoolean;
  /** Investor-detail "new" grid columns (share breakdowns, Say-on-Pay frequency, N-PX filter). */
  REACT_APP_ADVANCED_VOTING_DATA_SEARCH_DATA_VIEW_NEW_COLOUMNS?: EnvStringBoolean;
  REACT_APP_LOGGING_ENABLED?: EnvStringBoolean;
  REACT_APP_P4P_MODELER_LINK?: string;
  REACT_APP_P4P_SNAPSHOT_LINK?: string;
  /** QuickSight dashboard ID for compensation incentives embed (test vs live per environment). */
  REACT_APP_QUICKSIGHT_INCENTIVES_DASHBOARD_ID?: string;
  /** QuickSight dashboard ID for governance auditor fees and material weaknesses tool. */
  REACT_APP_QUICKSIGHT_AUDITOR_FEES_DASHBOARD_ID?: string;
  /** QuickSight dashboard ID for the governance related party transactions tool (pre-prod vs prod per environment). */
  REACT_APP_QUICKSIGHT_RELATED_PARTY_TRANSACTIONS_DASHBOARD_ID?: string;
  /** QuickSight dashboard ID for the voting investor voting rationale tool. */
  REACT_APP_QUICKSIGHT_INVESTOR_VOTING_RATIONALE_DASHBOARD_ID?: string;
  /** QuickSight dashboard ID for the compensation analysis dashboard embed (test vs live per environment). */
  REACT_APP_QUICKSIGHT_COMPENSATION_ANALYSIS_DASHBOARD_ID?: string;
}

// Note: declaring env type in namespace causes problems in monorepo, as of now,
// types overlap between different apps in same folder, so using typecast instead
// On the upside, allows to change where config comes from, can be more dynamic than just .env
/** Typed `process.env` */
// Direct usage of 'process.env' can cause issues, especially in environment-independent contexts.
// eslint-disable-next-line no-undef
export const FE_ENV: FrontendEnvType = process.env as unknown as FrontendEnvType;

/** Truthy if value is `1`, `"1"` or `"true"`. */
export function isTruthyEnvVar(value: EnvStringBoolean | string | undefined): boolean {
  return ['1', 'true', 1].includes(value as EnvStringBoolean);
}
